<template>
  <div class="no-data" >
    <img src="../assets/img/noData1.png" alt="">
    <p>暂无数据</p>
  </div>
</template>

<script>
  export default {
    name: "noData"
  }
</script>

<style scoped lang="scss">

</style>